import {
    IProps,
    IRef,
} from '../types';

import React, {
    forwardRef,
    useImperativeHandle,
    useState,
} from 'react';

import {
    CLIENT_FIELD_TYPE,
} from 'entities/payment-methods/constants';

import {
    NumberInput,
} from 'components/inputs';

import {
    checkValue,
} from './helpers/check-value';
import {
    formatValue,
} from './helpers/format-value';

const NumberFieldInput = forwardRef<IRef, IProps>((props, ref) => {
    const [value, setValue] = useState<string | null>(null);
    const [isError, setIsError] = useState(false);

    const onChangeValue = (value: string | null) => {
        setValue(value);
        setIsError(false);
    };

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return {
                    key: props.clientField.key,
                    value: formatValue(value),
                };
            },
            setValue(value) {
                setValue(value?.value ?? null);
            },
            validate() {
                if (props.clientField.validation.type !== CLIENT_FIELD_TYPE.NUMBER) {
                    return false;
                }

                const isValid = checkValue(
                    value,
                    props.clientField.validation.minLength,
                    props.clientField.validation.maxLength
                );

                setIsError(!isValid);

                return isValid;
            },
        };
    });

    if (props.clientField.validation.type !== CLIENT_FIELD_TYPE.NUMBER) {
        return null;
    }

    return (
        <NumberInput
            label={props.clientField.name}
            value={value}
            maxLength={props.clientField.validation.maxLength}
            isDisabled={props.isDisabled}
            isError={isError}
            errorMessage={isError ? props.clientField.validationHint : null}
            onChangeValue={onChangeValue}
        />
    );
});

export default NumberFieldInput;
